export enum RestaurantStatus {
  Active = 'active',
  Archived = 'archived',
  ComingSoon = 'coming_soon',
}

export interface RestaurantEvent {
  id: string;
  name: string;
  description: string;
  price: number;
  serviceChargePercentage: number;
  guestLimit: number;
  shift: {
    id: string;
    name: string;
    startDate: string;
    endDate: string | null;
    repeat: string[];
    startTime: string;
    endTime: string;
  };
  images: RestaurantEventImage[];
}

export interface RestaurantEventImage {
  id: string;
  imageKey: string;
}
